export const MySubscription = {
  en: {
    // Loading state
    loading: 'Loading',

    // No subscriptions state
    noSubscriptions: 'No subscriptions',
    goTo: 'Go to',
    subscriptionsPage: 'subscriptions page',
    toPurchase: 'to purchase',

    // Active subscription
    uahPerMonth: 'UAH/month',
    processing: 'Processing...',
    serviceEndDate: 'Service end date',

    // Suspended subscription warnings
    possibleReasons: 'Possible reasons',
    blockedCard: 'Card is blocked',
    blockedCardDescription:
      'Contact your bank to unblock the card. Payment will be retried until {{date}}',
    insufficientFunds: 'Insufficient funds',
    insufficientFundsDescription:
      'Top up your card. Payment will be retried until {{date}}',
    paymentLimit: 'Payment limit exceeded',
    paymentLimitDescription:
      'Increase the limit or use another card. Payment will be retried until {{date}}',

    // Subscription for resubscribe
    availableSubscriptions: 'Available for renewal',
    restore: 'Restore',
    restoreWithoutStartPayment: 'Restore without payment until',
  },
  uk: {
    // Loading state
    loading: 'Завантаження',

    // No subscriptions state
    noSubscriptions: 'Підписки відсутні',
    goTo: 'Перейдіть на',
    subscriptionsPage: 'сторінку підписок',
    toPurchase: 'для придбання',

    // Active subscription
    uahPerMonth: 'грн/місяць',
    processing: 'Обробка...',
    serviceEndDate: 'Дата закінчення сервісу',

    // Suspended subscription warnings
    possibleReasons: 'Можливі причини',
    blockedCard: 'Картка заблокована',
    blockedCardDescription:
      'Зверніться до банку для розблокування картки. Спроби списання будуть до {{date}}',
    insufficientFunds: 'Недостатньо коштів',
    insufficientFundsDescription:
      'Поповніть картку. Спроби списання будуть до {{date}}',
    paymentLimit: 'Перевищено ліміт платежів',
    paymentLimitDescription:
      'Збільшіть ліміт або використайте іншу картку. Спроби списання будуть до {{date}}',

    // Subscription for resubscribe
    availableSubscriptions: 'Доступні для поновлення',
    restore: 'Поновити',
    restoreWithoutStartPayment: 'Поновити без оплати до',
  },
};
